import { render, staticRenderFns } from "./PaySuc.vue?vue&type=template&id=f4ea149a&scoped=true&"
import script from "./PaySuc.vue?vue&type=script&lang=js&"
export * from "./PaySuc.vue?vue&type=script&lang=js&"
import style0 from "./PaySuc.vue?vue&type=style&index=0&id=f4ea149a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ea149a",
  null
  
)

export default component.exports